import styled from '@emotion/styled'
import { useTranslation } from 'next-i18next'
import useDrawer from 'modules/drawer/state/use-drawer'
import { getAnalyticsInstance } from '../../analytics/analytics'

export const FAQ_DRAWER_OPENER_DATA_ID = 'faq-drawer-opener'

const Opener = styled.div<{ color: string }>`
  color: ${(props) => props.color};
  cursor: pointer;
  font-size: 0.85em;
  text-align: center;

  &:hover {
    text-decoration: underline;
  }
`

const FAQDrawerOpener = ({ textColor = 'white' }) => {
  const { t } = useTranslation()
  const drawer = useDrawer()

  const openFAQDrawer = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.preventDefault()

    // Track FAQ click event
    getAnalyticsInstance().track('studio_faq_open')

    drawer.open('faq')
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      openFAQDrawer(e)
    }
  }

  return (
    <Opener
      tabIndex={0}
      onClick={openFAQDrawer}
      color={textColor}
      role="button"
      aria-label={t('faqDrawerOpener.opener.ariaLabel', 'Open FAQ drawer')}
      data-id={FAQ_DRAWER_OPENER_DATA_ID}
      onKeyDown={handleKeyDown}
    >
      {t('faqDrawerOpener.opener.label', 'Frequently asked questions')}
    </Opener>
  )
}

export default FAQDrawerOpener
